import { CASES } from './constants';
import {
    PAGINATION_STORAGE_KEYS,
    DEFAULT_PAGE_SIZE_OPTIONS,
    getStoredItemsPerPage,
    getInitialPaginationRange,
    withPreservedPagination,
    persistItemsPerPage,
} from 'datastage/utils/paginationPreferences.js';

/**
 * Gets the initial rights sort from localStorage.
 * Falls back to ['id', 'DESC'] if not found.
 */
const getInitialRightsSort = () => {
    const saved = localStorage.getItem('rightSort');
    return saved ? JSON.parse(saved) : ['id', 'DESC'];
};

/**
 * Gets the initial items per page from localStorage.
 * Falls back to 20 (Rights default) if not found.
 */
const getInitialItemsPerPage = () => {
    return getStoredItemsPerPage(PAGINATION_STORAGE_KEYS.rights, 20);
};

// Initialize with stored preference
const initialItemsPerPage = getInitialItemsPerPage();

/**
 * Initial state for the rights slice.
 *
 * Key state values:
 * - rights: Array of rights objects for the grid
 * - filterForm: Search form field values
 * - isAssociateOpen: Boolean to control associate drawer visibility
 * - refreshRights: Boolean flag to trigger grid refresh from other components
 * - itemsPerPage: User's persisted page size preference (from localStorage)
 */
const initialState = {
    rights: [],
    details: [],
    isAssociateOpen: false,
    associationForm: {
        dealNotFound: false,
        catalogNotFound: false,
        catalog: [],
        deal: [],
        dealSearchResults: [],
        catalogSearchResults: [],
        dealSelected: '',
        catalogSelected: '',
        dealSearchInput: '',
        catalogSearchInput: '',
    },
    filterForm: {
        rightId: '',
        rightTitle: '',
        rightTemplate: '',
        dealId: '',
        catalogId: '',
        hasDeal: true,
        hasCatalog: true,
        showFailedAssociations: false,
    },
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    rightRange: getInitialPaginationRange(initialItemsPerPage),
    rightSort: getInitialRightsSort(),
    defaultFilterRange: getInitialPaginationRange(initialItemsPerPage),
    itemsPerPage: initialItemsPerPage,
    pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    // Flag to trigger grid refresh from other components
    refreshRights: false,
};

export function rights(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_RIGHTS: {
            // Persist sort preference to localStorage
            if (payload.rightSort) {
                localStorage.setItem('rightSort', JSON.stringify(payload.rightSort));
            }
            // Persist page size preference to localStorage
            if (payload.itemsPerPage !== undefined) {
                persistItemsPerPage(PAGINATION_STORAGE_KEYS.rights, payload.itemsPerPage);
            }
            return { ...state, ...payload };
        }
        case CASES.UPDATE_RIGHTS_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_ASSOCIATIONS_DRAWER: {
            return { ...state, associationForm: initialState.associationForm };
        }
        case CASES.CLEAR_RIGHTS: {
            // Preserve pagination preferences when clearing
            return withPreservedPagination(
                state,
                {
                    ...initialState,
                    rightSort: state.rightSort,
                },
                ['rightRange', 'defaultFilterRange']
            );
        }
        default:
            return state;
    }
}
